export const CATEGORY_IDS = {
  crew: 'crew',
  purchasing: 'purchasing',
  forms: 'forms',
  captain_reports: 'captain_reports',
  pms: 'pms',
  accounting: 'accounting',
  invoices: 'invoices',
  mga: 'mga',
  evaluations: 'evaluations',
  external_email: 'external_email',
  itinerary_onboard: 'itinerary_onboard',
  manuals_export: 'manuals_export',
  onboard_sync: 'onboard_sync'
} as const;

export type CategoryId = (typeof CATEGORY_IDS)[keyof typeof CATEGORY_IDS];

export type SettingsCategory = {
  id: CategoryId;
  title: string;
};

export const SETTINGS_CATEGORIES: SettingsCategory[] = [
  { id: CATEGORY_IDS.crew, title: 'Crew' },
  { id: CATEGORY_IDS.purchasing, title: 'Purchasing' },
  { id: CATEGORY_IDS.forms, title: 'Forms' },
  { id: CATEGORY_IDS.captain_reports, title: 'Captain Reports' },
  { id: CATEGORY_IDS.pms, title: 'PMS' },
  { id: CATEGORY_IDS.accounting, title: 'Accounting' },
  { id: CATEGORY_IDS.invoices, title: 'Invoices' },
  { id: CATEGORY_IDS.mga, title: 'MGA' },
  { id: CATEGORY_IDS.evaluations, title: 'Evaluations' },
  { id: CATEGORY_IDS.external_email, title: 'External Email Integration' },
  { id: CATEGORY_IDS.itinerary_onboard, title: 'Itinerary Onboard' },
  { id: CATEGORY_IDS.manuals_export, title: 'Manuals Export' },
  { id: CATEGORY_IDS.onboard_sync, title: 'Onboard Sync' }
];
